export default [
    {
        path: '/accounts',
        name: 'accounts',
        component: () => import('@/views/Aws/AwsAccounts/AwsAccounts'),
    },
    {
        path: '/invoices',
        name: 'invoices',
        component: () => import('@/views/Aws/AwsInvoices/AwsInvoices'),
    },
    {
        path: '/contracts',
        name: 'contracts',
        component: () => import('@/views/Aws/AwsContracts/AwsContracts'),
    },
    {
        path: '/cost-explorer/:accountId',
        name: 'cost-explorer',
        component: () => import('@/views/Aws/AwsCostExplorer/AwsCostExplorer'),
    },
    {
        path: '/billing-detail/:awsAccountId',
        name: 'billing-detail',
        component: () =>
            import('@/views/Aws/AwsBillingDetail/AwsBillingDetail'),
    },
];
